import { create } from "zustand";

export interface AuthUser {
  id: string;
  email: string;
  username: string;
  is_active: boolean;
  roles: string[];
  tenant_id: string | null;
  // RM-14: added list of permission codes from backend
  // format: ["inventory.view", "inventory.manage", "production.view", ...]
  permissions: string[];
}

interface AuthState {
  status: "idle" | "authenticating" | "authenticated" | "unauthenticated";
  user: AuthUser | null;
  setAuthenticated: (user: AuthUser) => void;
  setUnauthenticated: () => void;
  setAuthenticating: () => void;
}

/**
 * فقط وضعیت را نگه می‌دارد؛ خودِ توکن‌ها در tokenStorage.ts هستند (جدا نگه
 * داشته شده تا تغییر لاجیک ذخیره‌سازی توکن مجبور به تغییر این store نشود).
 */
export const useAuthStore = create<AuthState>((set) => ({
  status: "idle",
  user: null,
  setAuthenticated: (user) => set({ status: "authenticated", user }),
  setUnauthenticated: () => set({ status: "unauthenticated", user: null }),
  setAuthenticating: () => set({ status: "authenticating" }),
}));
